import { useState } from 'react'
import { Form, Button } from 'react-bootstrap'
import { useTranslation } from "react-i18next"
import { useNavigate } from 'react-router-dom'
import { useAuth } from '../../components/auth/useAuth'
import Axios from 'axios'
import { toastSuccess, toastError } from '../../components/swal/toast'

export default function ChangePassword() {
    const { t } = useTranslation()
    const navigate = useNavigate()
    const { setClientauth } = useAuth()
    const [password, setPassword] = useState('')
    const [confirmPassword, setConfirmPassword] = useState('')
    const [submitting, setSubmitting] = useState(false)

    const handleSubmit = async (e) => {
        e.preventDefault()
        if (password !== confirmPassword) {
            toastError(t('passwordreset.passwordsdoesnotmatch'))
            return
        }
        setSubmitting(true)
        try {
            await Axios.put(process.env.REACT_APP_DB_ADDRESS + '/api/user/change-password', { password }, {
                headers: { auth: localStorage.getItem('jwt') }
            }).then(res => {
                if (res.data.token) {
                    localStorage.setItem('jwt', res.data.token)
                }
            })
            const token = localStorage.getItem('jwt')
            if (token) {
                const decoded = require('jwt-decode').jwtDecode(token)
                decoded.mustChangePassword = false
                setClientauth(decoded)
            }
            toastSuccess(t('passwordreset.changesuccess'))
            navigate('/teacher/dashboard')
        } catch (error) {
            toastError(t('passwordreset.changeerror'))
        }
        setSubmitting(false)
    }

    return (
        <div className='login-page'>
            <div className='login-card-wrapper'>
                <div className='login-card'>
                    <div className='login-card-header'>
                        <h3 className='fw-bold mb-0' style={{ color: '#fff' }}>{t('passwordreset.question')}</h3>
                        <p className='mt-2 mb-0' style={{ color: 'rgba(255,255,255,0.8)' }}>{t('passwordreset.help')}</p>
                    </div>
                    <div className='login-card-body'>
                        <Form onSubmit={handleSubmit}>
                            <Form.Group className='mb-3'>
                                <Form.Label>{t('passwordreset.new_password')}</Form.Label>
                                <Form.Control type='password' value={password} onChange={(e) => setPassword(e.target.value)} className='login-input' required />
                            </Form.Group>
                            <Form.Group className='mb-3'>
                                <Form.Label>{t('passwordreset.confirm_password')}</Form.Label>
                                <Form.Control type='password' value={confirmPassword} onChange={(e) => setConfirmPassword(e.target.value)} className='login-input' required />
                            </Form.Group>
                            <Button variant='danger' type='submit' className='w-100 login-submit-btn' disabled={submitting}>
                                {submitting ? <span className="spinner-border spinner-border-sm"></span> : t('passwordreset.submit')}
                            </Button>
                        </Form>
                    </div>
                </div>
            </div>
        </div>
    )
}
